<div class="modal-body vtr-modal-license"
	id="license-dialog"
	tabindex="-1"
	role="dialog">
	<div class="article-content"
		[hidden]="!loading">
		<div class="article-body">
			<div class="spinner-content">
				<div class="spinner-border text-primary progress-spinner"
					role="status"></div>
			</div>
		</div>
	</div>
	<div tabindex="0" class="empty" id="license-dialog-empty"></div>
	<div class="article-content"
		[hidden]="type !== 'txt' || loading">
		<div class="article-body"
			tabindex="0"
			[innerHTML]="articleBody"></div>
	</div>
	<div class="iframe-content"
		[hidden]="type === 'txt' || loading">
		<iframe id="license-agreement-iframe"
			class="article-frame"
			src=""
			attr.sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
			width="100%"
			height="100%"
			tabindex="0"></iframe>
	</div>
	<div role="button"
		class="close-btn"
		tabindex="0"
		id="btn-{{licenseModalMetrics.closeButton}}"
		aria-label="close"
		(keyup.enter)="closeModal()"
		(click)="closeModal()">
		<img [src]=" 'assets/icons/Close.svg' | svgInline | async"
			alt=""
			srcset="">
	</div>
</div>
